import { render, staticRenderFns } from "./addhouse.vue?vue&type=template&id=67de88f4"
import script from "./addhouse.vue?vue&type=script&lang=js"
export * from "./addhouse.vue?vue&type=script&lang=js"
import style0 from "./addhouse.vue?vue&type=style&index=0&id=67de88f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports